import styles from "./styles.module.scss";
import ErrorTippy from "../../../components/Programs/ErrorTippy";
import { useFormContext } from "react-hook-form";
import React from "react";
import ToolTip from "app/routes/Scheduling/ToolTip";

const TaxItem = ({
  tagTitle,
  fieldName,
  defaultValue = null,
  isEditable = true,
  showInput = true,
  highField = false,
  error = null,
  hideLabel = false,
  longField = false,
  placeholder = null,
  isNumberOnly = null,
  tooltipText = null,
  checkValue=null,
  description = null,
  description2 = null,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const registerProps =  register(fieldName);

  const inputStyling = isEditable
    ? styles.input_container
    : styles.input_container_not_editable;

  const handleNumberInput = (event) => {
    let value = event.target.value;
    value = value.replace(/[^0-9.]/g, '');

    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
    }

    event.target.value = value;
  };

  return (
    <div className={styles.container}>
       <input
        {...register('tax_option')}
        type="radio"
        name="tax_option"
        value={checkValue}
        className={styles.custom_radio_input}
      />
    <div className={styles.option_container}>
      {!hideLabel && (
        <div className={styles.select_container}>
          <p
            className={`${styles.tag} ${
              highField ? styles.high_field_tag : ""
            }`}
          >
            {tagTitle}
          </p>
          {tooltipText && <ToolTip text={tooltipText} />}
        </div>
      )}
      {description && <div className={styles.description}> {description} </div>}
      {description2 && <div className={styles.description2}> {description2} </div>}
      <div
        className={`${
          error
            ? styles.error_line_container
            : styles.line_container
        } ${highField ? styles.p_13_8 : styles.p_10} `}
      >
       {showInput && (
         <ErrorTippy placement="top-end" errors={errors} field_name={fieldName}>
           <div className={styles.percent_wrapper}>
            <input
              defaultValue={defaultValue}
              data-cy={fieldName}
              data-testid={fieldName}
              placeholder={placeholder}
              className={`${inputStyling} ${
                longField ? styles.long_field : ""
              }`}
              {...registerProps}
              readOnly={!isEditable}
              onChange={isNumberOnly ? handleNumberInput : null}
            />
           {isNumberOnly && <span className={styles.percent_sign}>%</span>}
          </div>
         </ErrorTippy>
       )
        }
      </div>
    </div>
    </div>
  );
};

export default TaxItem;
